import React from 'react'
import {
  Button, Form, Input, message, Typography, Checkbox
} from 'antd'
import { useNavigate } from 'react-router-dom'
import { RegisterFormValues } from '../../services/authService'
import useAuth from '../../hooks/useAuth'

const RegistrationForm: React.FC = () => {
  const navigate = useNavigate()
  const { register, loading } = useAuth()

  const onFinish = (values: RegisterFormValues) => register(values)
    .then(() => navigate('/'))
    .catch((error) => message.error(error.response.data.message))

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  return (
        <Form
            name="basic"
            layout="vertical"
            labelAlign="left"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
        >
            <Typography.Title level={3}>Регистрация</Typography.Title>
            <Form.Item
                label="Имя"
                name="firstName"
                rules={[
                  { required: true, message: 'Пожалуйста введите Ваше имя!' }
                ]}
            >
                <Input/>
            </Form.Item>

            <Form.Item
                label="Фамилия"
                name="lastName"
                rules={[
                  { required: true, message: 'Пожалуйста введите Вашу фамилию!' }
                ]}
            >
                <Input/>
            </Form.Item>

            <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: 'Пожалуйста введите ваш Email!' },
                  { type: 'email', message: 'Email введен не верно' }
                ]}
            >
                <Input/>
            </Form.Item>

            <Form.Item
                label="Пароль"
                name="password"
                rules={[{ required: true, message: 'Пожалуйста введите ваш пароль!' }]}
            >
                <Input.Password/>
            </Form.Item>

            <Form.Item
                name="confirm"
                label="Подтвердите пароль"
                dependencies={['password']}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: 'Пожалуйста введите ваш пароль!'
                  },
                  ({ getFieldValue }) => ({
                    validator (_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve()
                      }
                      return Promise.reject(new Error('Пароли должны совпадать'))
                    }
                  })
                ]}
            >
                <Input.Password/>
            </Form.Item>

            <Form.Item
                name="agreement"
                valuePropName="checked"
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject(new Error('Необходимо дать согласие на обработку персональных данных'))
                  }
                ]}
            >
                <Checkbox>
                    Я даю согласие на обработку персональных данных в соответствии с Политикой обработки Персональных данных
                </Checkbox>
            </Form.Item>

            <Form.Item
                name="marketingConsent"
                valuePropName="checked"
                initialValue={false}
            >
                <Checkbox>
                    Я даю согласие на рассылку рекламных материалов Платформы Prisma, информирование о новых отчётах и исследованиях
                </Checkbox>
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit" size="large" block loading={loading}>
                    Зарегистрироваться
                </Button>
            </Form.Item>

            <Form.Item>
                <Typography.Text>
                    Заполняя данную форму вы соглашаетесь с нашей Политикой обработки Ваших Персональных данных - ознакомиться с Политикой обработки Персональных данных можно по следующей <a href="https://prismaplatform.ru/policy" target="_blank" rel="noreferrer">ссылке</a>.
                </Typography.Text>
            </Form.Item>

            <Form.Item>
                <Typography.Text>Еще уже есть аккаунт?</Typography.Text>
                <Button type="link" onClick={() => navigate('/')}>Авторизация</Button>
            </Form.Item>
        </Form>
  )
}

export default RegistrationForm
